import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	watchOptions: {
		id: 'bulk-operations-core.toolbar.use-watch-action.watch-options',
		defaultMessage: 'Watch options',
		description: 'The text will be shown inside the toolbar to open a menu of watching actions.',
	},
	startWatching: {
		id: 'bulk-operations-core.toolbar.use-watch-action.start-watching',
		defaultMessage: 'Start watching',
		description:
			'The text will be shown inside the watch options menu in the toolbar to allow the the user to start watching the selected issues.',
	},
	stopWatching: {
		id: 'bulk-operations-core.toolbar.use-watch-action.stop-watching',
		defaultMessage: 'Stop watching',
		description:
			'The text will be shown inside the watch options menu in the toolbar to allow the the user to stop watching the selected issues.',
	},
	successFlagDescriptionStartWatching: {
		id: 'bulk-operations-core.toolbar.use-watch-action.success-flag-description-start-watching',
		defaultMessage:
			"You're watching {itemCount, plural, one {this work item} other {# work items}}",
		description:
			'The text will be shown inside the success flag after the bulk watch successfully completes.',
	},
	successFlagDescriptionStopWatching: {
		id: 'bulk-operations-core.toolbar.use-watch-action.success-flag-description-stop-watching',
		defaultMessage:
			"You aren't watching {itemCount, plural, one {this work item} other {# work items}}",
		description:
			'The text will be shown inside the success flag after the bulk unwatch successfully completes.',
	},
});
